// Utility `cn()` — merge les class names Tailwind en résolvant les conflits.
// Source : PRD 10 §5 design tokens + shadcn/ui convention.
//
// Usage : `<div className={cn("px-4", isActive && "bg-accent", className)}>`
import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
